var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"700"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.biz)?_c('v-card',[_c('v-card-title',[_vm._v("Business Hours")]),_c('v-card-text',[_c('Hours',{attrs:{"biz":_vm.biz},on:{"updated":_vm.updated}})],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }